import {CHANGE_STATUS} from "../mutations";
import {STATUSES} from "../../components/statuses";
import find from 'lodash/find';

const table = '<table class="questions-answers__block-table">' +
'<tr>' +
'<td>Транши</td>' +
'<td>Максимальная сумма</td>' +
'<td>Комиссия</td>' +
'</tr><tr>' +
'<td>1-й транш</td>' +
'<td>до 500 000 тенге</td>' +
'<td>3%</td>' +
'</tr><tr>' +
'<td>2-й транш</td>' +
'<td>до 1 000 000 тенге</td>' +
'<td>2%</td>' +
'</tr><tr>' +
'<td>3-й транш</td>' +
'<td>до 800 000 тенге</td>' +
'<td>2%</td>' +
'</tr><tr>' +
'<td>4-й транш</td>' +
'<td>до 1 200 000 тенге</td>' +
'<td>1%</td>' +
'</tr>' +
'</table>';

const faq = {
	namespaced: true,
	state: {
		listContent: [
			{
				name: 'often-asked',
				list: [
					{
						name: 'where-go',
						text: 'Куда обращаться за микрокредитом?',
						content: 'Чтобы получить микрокредит, нужно заполнить заявку на сайте microfin.kz. Для подачи заявки на микрокредит не нужно никуда ездить, всё делаем через интернет. Принимаем заявки на микрокредит в любой день круглые сутки.'
					},
					{
						name: 'how-fast',
						text: 'Как быстро я получу деньги?',
						content: 'Время получения денег в случае положительного решения по заявке на микрокредит – 1-3 дня. Весь процесс получения микрокредита выглядит так:<br/><br/>' +
						'<ol class="questions-answers__block-num-list">' +
						'<li>Подаёте заявку на сайте microfin.kz. Это займёт у вас не более получаса.</li>' +
						'<li>Узнаёте о решении в течение 30 минут после отправки заявки. При первом обращении – только в рабочие дни, при повторном – в любой день недели.</li>' +
						'<li>Получаем подписанный договор и сразу переводим деньги на ваш банковский счёт или карту Visa/MasterCard сразу после получения подписанного договора.</li>' +
						'<li>Банк зачисляет деньги на ваш банковский счёт или карту в течение 1-3 дней. Если вы не получили деньги в течение трёх дней с момента подписания договора, стоит обратиться в Службу поддержки вашего банка. От него зависит время зачисления денег.</li>' +
						'</ol>'
					},
					{
						name: 'is-possible',
						text: 'Можно ли подать заявку в нерабочее время или выходные дни?',
						content: 'Подать заявку вы можете в любое удобное для вас время. Решение по заявке мы сообщим в рабочий день, работаем с 8:00 до 20:00.'
					},
					{
						name: 'what-amount',
						text: 'Какую сумму я могу получить?',
						content: 'Вы можете получить от 100 000 до 1 000 000 тенге.'
					},
					{
						name: 'why-refuse',
						text: 'Почему мне отказали в микрокредите?',
						content: 'Аналитическая система принимает в расчет множество факторов, поэтому назвать точную причину отказа невозможно. Часто эту причину нужно искать в плохой кредитной истории, недостаточном уровне дохода или других действующих кредитах.'
					},
					{
						name: 'electronic-signature',
						text: 'Что такое электронная подпись (ЭЦП) и нужна ли она мне?',
						content: 'ЭЦП – это личная электронная цифровая подпись. ЭЦП – законный способ подписания документов, электронная подпись имеет такую же юридическую силу, как обычная. Получить ЭЦП можно на сайте электронного правительства egov.kz. Получение электронного ключа может занять несколько дней. Если электронный ключ уже есть, вы быстрее завершите подачу заявки, так как в этом случае не нужно дожидаться курьера с договором.<br/><br/>' +
						'Если вы ещё не получили ЭЦП, можете подписать договор вживую в день одобрения заявки или на следующий. Договор доставит наш курьер в удобное для вас место. Такая возможность сейчас есть только у жителей <b>Алматы и Алматинской области</b>.'
					},
				]
			},
			{
				name: 'o-micro',
				list: [
					{
						name: 'what-micro',
						text: 'Что такое Микро?',
						content: 'Микро – это микрофинансовая организация, наша деятельность регулируется законодательством Республики Казахстан. Мы предоставляем самый простой и удобный способ получить микрокредит в Казахстане. Для подачи заявки понадобятся только удостоверение личности, доступ к интернету и мобильный телефон. Решение по заявке сообщаем в течение 30 минут в рабочее время, деньги перечисляем сразу после подписания договора. Договор можно подписать на сайте электронной подписью – либо наш курьер доставит договор в удобное место.'
					},
					{
						name: 'bank-details',
						text: 'Банковские реквизиты',
						content: '<table  width="100%">' +
						'<tr><td width="50%">Получатель:</td><td width="50%">МФО MicroFin» ТОО</td></tr>' +
						'<tr><td width="50%">БИН:</td><td width="50%">231140034522</td></tr>' +
						'<tr><td width="50%">Номер счёта/ IBAN/ ИИК:</td><td width="50%">KZ04601A861026938571</td></tr>' +
						'<tr><td width="50%">Наименование банка:</td><td width="50%">АФ АО «Народный банк»</td></tr>' +
						'<tr><td width="50%">БИК:</td><td width="50%">HSBKKZKX</td></tr>' +
						'<tr><td width="50%">КБЕ:</td><td width="50%">17</td></tr>' +
						'</table>'
					},
					{
						name: 'what-micro-credit',
						text: 'Что такое «Микрокредит»?',
						content: '«Микрокредит» предоставляется физическим лицам на любые цели и погашается за счёт личных доходов. На срок от 1 месяца до 12 месяцев можно получить сумму от 100 000 до 1 000 000 тенге. Преимуществом «Микрокредита» является то, что он не требует залога и  выплачивается ежемесячными платежами по графику.'
					},
					{
						name: 'what-business-line',
						text: 'Что такое «Бизнес кредит»?',
						content: '«Бизнес кредит» – это кредитная линия для предпринимателей, она открывается на развитие бизнеса и погашается за счет доходов от предпринимательской деятельности.<br/><br/>' +
						'Максимальная сумма займа – 3 000 000 тенге. Микрокредит предоставляется на общий срок до 12 месяцев в виде траншей, то есть перечисляется частями. Закрыв очередной транш, заёмщик может оформить заявку на новый транш с  большей суммой и более продолжительным сроком.<br/><br/>' +
						'Вознаграждение начисляется только на полученную траншем сумму. Деньги в обороте бизнеса находятся максимально долго: вознаграждение выплачивается ежемесячно, а сумма основного долга – единоразово последним платежом.'
					},
					{
						name: 'contrast-micro-credit__micro-loans',
						text: 'В чем отличие микрокредитов Микро от других микрозаймов?',
						content: 'Сумма микрокредита. «Микрокредит» и «Бизнес кредит» выдаются для серьёзных личных приобретений и полноценного осуществления предпринимательской деятельности.<br/><br/>' +
						'График погашения. В отличие от других микрокредитов, наши микрокредиты погашают не одним платежом в конце срока, а пошагово по ежемесячному графику. В этом случае из личного бюджета или оборотных средств не придется извлекать сразу большую сумму.'
					},
					{
						name: 'contrast-micro-credit-business-line',
						text: 'Чем «Микрокредит» отличается от «Бизнес-линии»?',
						content: 'Микрокредит – это потребительский микрокредит, то есть он выдаётся на личные цели: дорогостоящие покупки, путешествия, оплату учебы или, например, организацию свадьбы.<br/><br/>' +
						'Бизнес кредит, в отличие от Микрокредита, открывается для субъектов малого предпринимательства и предназначена для пополнения оборотных средств.'
					},
					{
						name: 'contrast-business-line-micro-credit',
						text: 'Чем  «Бизнес кредит» отличается от «Микрокредита»?',
						content: 'Бизнес кредит – это кредитная линия для индивидуальных предпринимателей, которые занимаются оптово-розничной торговлей, предоставлением частных услуг. Заёмщик погашает микрокредит за счёт доходов от предпринимательской деятельности.<br/><br/>' +
						'Микрокредит, в отличие от Бизнес-линии, выдаётся на личные цели, не связанные с ведением бизнеса.'
					},
				]
			},
			{
				name: 'credit-terms',
				selector: true,
				list: [
					{
						name: 'micro-credit',
						text: 'Микрокредит',
						content: [
							{
								name: 'what-amount',
								text: 'Какую сумму я могу получить?',
								content: 'Вы можете получить от 100 000 до 1 000 000 тенге.'
							},
							{
								name: 'how-term',
								text: 'На какой срок выдаётся Микрокредит?',
								content: 'Микрокредит выдаётся на срок от 1 месяца до 12 месяцев.'
							},
							{
								name: 'how-pay',
								text: 'Сколько я заплачу за микрокредит?',
								content: 'Ставка вознаграждения за микрокредит составляет 55% годовых, это около 0,1% в день.'
							},
							{
								name: 'additional-payments',
								text: 'Есть ли дополнительные платежи и сборы?',
								content: 'Мы не взимаем никаких дополнительных платежей за Микрокредит.'
							},
						],
					},
					{
						name: 'business-line',
						text: 'Бизнес кредит',
						content: [
							{
								name: 'what-amount',
								text: 'Какую сумму я могу получить?',
								content: 'Вы можете получить до 1 000 000 тенге.'
							},
							{
								name: 'how-term',
								text: 'На какой срок открывается Бизнес кредит?',
								content: 'Бизнес кредит открывается на срок до 12 месяцев.'
							},
							{
								name: 'how-pay',
								text: 'Сколько я заплачу за микрокредит?',
								content: 'Ставка вознаграждения за микрокредит составляет 55% годовых.' +
								'<br/><br/>Также предусмотрена дополнительная комиссия от 1% до 3% в зависимости от суммы полученного транша.'
							},
							{
								name: 'additional-payments',
								text: 'Есть ли дополнительные платежи и сборы?',
								content: 'Помимо вознаграждения за использование микрокредита, существует комиссия за каждый предоставленный транш:' +
								'<br/><br/>'+table
							},
						],
					}
				],
			},
			{
				name: 'get-loan',
				list: [
					{
						name: 'mandatory-requirements-micro-credit',
						text: 'Каковы обязательные требования для получения Микрокредита?',
						content: 'Мы выдаём микрокредиты гражданам Республики Казахстан в возрасте от 21 года, с постоянным доходом в форме заработной платы.<br/><br/>'+
						'Для получения микрокредита у вас должны быть банковская карта или действующий счёт в казахстанском банке.'
					},
					{
						name: 'mandatory-requirements-business-line',
						text: 'Каковы обязательные требования для получения Бизнес линии?',
						content: 'Бизнес кредит может быть открыта гражданину Республики Казахстан в возрасте от 21 до 68 лет с действующим не менее 12 месяцев бизнесом в сфере услуг или торговли.<br/><br/>'+
						'У заёмщика должен быть действующий банковский счёт, а по его ИП не должно быть задолженности по налогам более 50 000 тенге.<br/><br/>'+
						'Если вы работаете без ИП или патента, то место ведения бизнеса должно быть в вашей собственности или находиться на рынке или в торговом доме.'
					},
					{
						name: 'must-have',
						text: 'Что нужно иметь при себе при подаче заявки?',
						content: 'Для подачи заявки на микрокредит вам потребуются электронная копия удостоверения личности или паспорта – и, конечно, доступ в интернет и мобильный номер телефона для верификации в системе.'
					},
					{
						name: 'needed-documents',
						text: 'Какие документы нужны для получения микрокредита?',
						content: 'Электронная копия удостоверения личности или паспорта прикрепляются один раз при первичной регистрации в Микро. Больше никаких документов и справок. При повторном обращении за микрокредитом в Микро копия личного документа уже не потребуется.'
					},
					{
						name: 'loan-overdue',
						text: 'У меня была просрочка по другому кредиту, смогу ли я получить новый микрокредит?',
						content: 'Просрочки по кредиту негативно влияют на вашу кредитную историю и могут стать причиной отказа в выдаче нового микрокредита. Но это не значит, что новый микрокредит нельзя будет получить. Мы учитываем множество факторов, которые в сумме могут позволить вам получить микрокредит.'
					},
					{
						name: 'other-loans',
						text: 'У меня есть другие займы, могу ли я взять еще микрокредит?',
						content: 'Другие действующие займы – не причина отказа в выдаче микрокредита, но может стать причиной одобрения меньшей, чем вы указали в заявке, суммы займа. Наша система анализирует размер дохода, количество и размер активных займов – и сумму ежемесячных выплат по ним.'
					},
					{
						name: 'which-city',
						text: 'В каком городе можно взять микрокредит?',
						content: 'Для получения микрокредита вам нужно будет подписать договор на микрокредит. Вы можете сделать это с помощью <a href=""><router-link to="/faq/loan-decision/electronic-signature">электронной подписи (ЭЦП)</router-link></a> из любого города, населённого пункта Казахстана или находясь за границей.<br/><br/>' +
						'Если электронной подписи нет, договор можно заверить живой подписью. Наш курьер доставит договор в удобное для вас место, если вы находитесь в <b>Астане, Алматы или Алматинской области</b>.'
					},
					{
						name: 'credit-abroad',
						text: 'Могу ли я подать заявку на микрокредит находясь за границей?',
						content: 'Да, если у вас есть электронная подпись (ЭЦП) для удаленного заверения договора. Второе условие – ваш номер мобильного телефон должен быть подключен к роумингу.'
					},
				]
			},
			{
				name: 'loan--application',
				list: [
					{
						name: 'apply-loan',
						text: 'Куда обращаться за микрокредитом?',
						content: 'Чтобы получить микрокредит, нужно заполнить заявку на сайте microfin.kz. Для подачи заявки на микрокредит не нужно никуда ездить, всё делаем через интернет. Принимаем заявки на микрокредит в любой день круглые сутки.'
					},
					{
						name: 'after-hours',
						text: 'Можно ли подать заявку в нерабочее время или выходные дни?',
						content: 'Подать заявку вы можете в любое удобное для вас время. Решение по заявке мы сообщим в рабочий день, работаем с 8:00 до 20:00.'
					},
					{
						name: 'other-methods',
						text: 'Есть ли другие способы подачи заявки?',
						content: 'Нет, заявку на микрокредит можно подать только на сайте microfin.kz.'
					},
					{
						name: 'credit-phone',
						text: 'Можно ли подать заявку на микрокредит по телефону?',
						content: 'Нет, заявку можно подать только на сайте microfin.kz в «Личном кабинете».'
					},
					{
						name: 'maximum-amount',
						text: 'Как я могу получить максимальную сумму?',
						content: 'При подаче заявки укажите максимально возможную сумму. Автоматическая система оценки проанализирует всю полученную от вас информацию и подтвердит эту сумму или предложит меньшую. Если ранее вы взяли и без задержек вернули микрокредит в Микро, при повторной заявке сумма одобренного микрокредита увеличится.'
					},
					{
						name: 'credit-relative',
						text: 'Могу ли я взять микрокредит на родственника или друга?',
						content: 'Вы сможете взять микрокредит только на свое имя. Личность нужно будет подтвердить, прикрепив к заявке фотографию своего удостоверения личности или паспорта.'
					},
					{
						name: 'attach-application',
						text: 'Как прикрепить к заявке документ, удостоверяющий личность?',
						content: 'Для подтверждения личности вы можете использовать действующее удостоверение или паспорт. Перед подачей заявки сфотографируйте обе стороны удостоверения или страницу паспорта с личными данными – и сохраните на компьютере. Переходите к заполнению заявки на сайте microfin.kz. Загрузить фотографии документа вам будет предложено на одном из этапов подготовки заявки.'
					},
					{
						name: 'what-IBAN',
						text: 'Что такое IBAN и как его узнать?',
						content: 'IBAN – это 20-значный номер вашего банковского счёта. Вы найдёте его в договоре с банком, личном кабинете на сайте банка или узнаете в Службе поддержки вашего банка.'
					},
					{
						name: 'made-mistake',
						text: 'Я допустил(а) ошибку при заполнения заявки на микрокредит. Как её исправить?',
						content: 'Вы можете самостоятельно отредактировать в «Личном кабинете» место работы, информацию о доходах и расходах, город проживания. Для изменения остальных сведений, например, данных документа, удостоверяющего личность, номера телефона, email, информации о дополнительных контактах нужно позвонить в наш контакт-центр.'
					},
					{
						name: 'cancel-application',
						text: 'Можно ли отменить заявку на микрокредит?',
						content: 'Заявку отменить можно. Когда наш оператор позвонит вам для верификации заявки, сообщите ему о своём желании.'
					},
					{
						name: 'refuse-loan',
						text: 'Можно ли отказаться от микрокредита?',
						content: 'Отказаться от микрокредита можно. Сообщите о своём желании оператору, когда он позвонит вам для верификации заявки.'
					},
				]
			},
			{
				name: 'loan-decision',
				list: [
					{
						name: 'how-know',
						text: 'Как я узнаю, одобрена ли моя заявка на микрокредит?',
						content: 'Мы отправим SMS-уведомление о решении по заявке на мобильный номер, указанный при регистрации. Статус заявки также отображается в вашем «Личном кабинете» на сайте microfin.kz.'
					},
					{
						name: 'what-time',
						text: 'Сколько времени занимает принятие решения по микрокредиту?',
						content: 'От момента получения заявки до решения проходит 30 минут.'
					},
					{
						name: 'report-decision',
						text: 'Сообщат ли мне о решении, если заявка подана в нерабочее время?',
						content: 'Если вы подали заявку на микрокредит в нерабочее время, мы обработаем её и сообщим о решении в первый рабочий день в рабочее время – с 8:00 до 20:00.'
					},
					{
						name: 'application-submitted',
						text: 'Заявка отправлена, но одобрение не происходит',
						content: 'Сначала убедитесь, что успешно прошли дополнительную верификацию: прикрепили фото личного документа. Если эти действия вы выполнили верно, позвоните в наш контакт-центр – вместе разрешим ситуацию.'
					},
					{
						name: 'smaller-amount',
						text: 'Мне одобрили меньшую сумму, чем была указана в заявке. Почему?',
						content: 'Наша система устанавливает кредитный лимит с учётом нескольких факторов, среди которых ваша кредитная история, количество и сумма открытых кредитов и ежемесячный доход. Вовремя погасив первый микрокредит, в следующий раз вы сможете претендовать на большую сумму.'
					},
					{
						name: 'electronic-signature',
						text: 'Что такое электронная подпись (ЭЦП) и нужна ли она мне?',
						content: 'ЭЦП – это личная электронная цифровая подпись. ЭЦП – законный способ подписания документов, электронная подпись имеет такую же юридическую силу, как обычная. Получить ЭЦП можно на сайте электронного правительства egov.kz. Получение электронного ключа может занять несколько дней. Если электронный ключ уже есть, вы быстрее завершите подачу заявки, так как в этом случае не нужно дожидаться курьера с договором.<br/><br/>' +
						'Если вы ещё не получили ЭЦП, можете подписать договор вживую в день одобрения заявки или на следующий. Договор доставит наш курьер в удобное для вас место. Такая возможность сейчас есть только у жителей <b>Алматы и Алматинской области</b>.'
					},
					{
						name: 'why-refused',
						text: 'Почему мне отказали в микрокредите?',
						content: 'Аналитическая система принимает в расчет множество факторов, поэтому назвать точную причину отказа невозможно. Часто эту причину нужно искать в плохой кредитной истории, недостаточном уровне дохода или других действующих кредитах. '
					},
					{
						name: 'repeated-failure',
						text: 'Можно ли подать заявку после отказа повторно?',
						content: 'Распространеннная причина отказа – незакрытые кредиты. Если это ваша ситуация – погасите текущий кредит и подайте заявку повторно. Тогда вероятность одобрения заявки будет выше.'
					},
				]
			},
			{
				name: 'receiving-money',
				list: [
					{
						name: 'quickly-get',
						text: 'Как быстро я получу деньги?',
						content: 'Время получения денег в случае положительного решения по заявке на микрокредит – 1-3 дня. Весь процесс получения микрокредита выглядит так:<br/><br/>' +
						'<ol class="questions-answers__block-num-list">' +
						'<li>Подаёте заявку на сайте microfin.kz. Это займёт у вас не более получаса.</li>' +
						'<li>Узнаёте о решении в течение 30 минут после отправки заявки. При первом обращении – только в рабочие дни, при повторном – в любой день недели.</li>' +
						'<li>Получаем подписанный договор и сразу переводим деньги на ваш банковский счёт или карту Visa/MasterCard сразу после получения подписанного договора.</li>' +
						'<li>Банк зачисляет деньги на ваш банковский счёт или карту в течение 1-3 дней. Если вы не получили деньги в течение трёх дней с момента подписания договора, стоит обратиться в Службу поддержки вашего банка. От него зависит время зачисления денег.</li>' +
						'</ol>'
					},
					{
						name: 'available-money',
						text: 'Как можно получить деньги?',
						content: '<table class="questions-answers__block-table">' +
						'<tr>' +
						'<td>Микрокредит</td>' +
						'<td>Бизнес кредит</td>' +
						'</td><tr>' +
						'<td>Получаете деньги на банковский счёт или банковскую карту Visa/MasterCard. Если к банковском счёту привязана банковская карта, деньги можно снять в любом банкомате.</td>' +
						'<td>Транши получаете на банковский счёт или банковскую карту Visa/MasterCard. Если к банковском счёту привязана банковская карта, деньги можно снять в любом банкомате.</td>' +
						'</td>' +
						'</table>'
					},
					{
						name: 'possible-obtain',
						text: 'Можно ли получить деньги наличными?',
						content: 'Нет. Микро перечисляет деньги только на ваш карточный или обычный банковский счёт. Наличные деньги вы можете получить в своём банке или через банкомат.'
					},
					{
						name: 'where-money',
						text: 'Куда деньги придут быстрее: на карту или счёт в банке?',
						content: 'Деньги быстрее приходят на карту.'
					},
					{
						name: 'use-card',
						text: 'Есть ли ограничения по использованию карт?',
						content: 'Карта должна быть выпущена только казахстанским банком в системах Visa или MasterCard.'
					},
				]
			},
			{
				name: 'money-back',
				selector: true,
				list: [
					{
						name: 'micro-credit',
						text: 'Микрокредит',
						content: [
							{
								name: 'return-money',
								text: 'Как можно вернуть деньги?',
								content: 'Есть несколько способов вернуть деньги:<br/><br/>' +
								'<ul class="questions-answers__block-num-list">' +
								'<li>банковской картой Visa или MasterCard в личном кабинете на microfin.kz,</li>' +
								'<li>с помощью кошельков Qiwi Wallet или «Личная касса — Касса 24»,</li>' +
								'<li>банковским переводом.</li>' +
								'</ul><br/><br/>' +
								'Подробнее о механизме возврата – <a href="">в разделе «Как вернуть деньги»</a>.',
							},
							{
								name: 'return-preferable',
								text: 'Какой способ возврата предпочтительнее?',
								content: 'Всё зависит от ваших предпочтений, выбирайте самый удобный способ для вас.',
							},
							{
								name: 'annuity-method-micro-credit',
								text: 'Что такое аннуитетный метод погашения?',
								content: 'При аннуитетных платежа вся сумма основного долга и вознаграждения делится на равные доли по месяцам. Каждый месяц в течение срока действия кредитного договора вы выплачиваете одинаковую сумму, и она не меняется.',
							},
							{
								name: 'differentiated-method-micro-credit',
								text: 'Что такое дифференцированный метод погашения?',
								content: 'При дифференцированных платежах сумма основного долга делится на равные части с учетом срока действия кредитного договора, а проценты по микрокредиту начисляются на остаток основного долга. Соответственно, по мере погашения микрокредита сумма вознаграждения уменьшается.',
							},
							{
								name: 'early-loan-micro-credit',
								text: 'Можно ли вернуть микрокредит досрочно?',
								content: 'Да, можно. Выбрать способ досрочного погашения можно в «Личном кабинете»: вернуть долг целиком или погасить микрокредит частично, уменьшив сумму основного долга или срок.',
							},
							{
								name: 'shorten-term-micro-credit',
								text: 'Можно ли сократить срок микрокредита?',
								content: 'Сократить срок микрокредита можно, досрочно погасив часть основного долга. В «Личном кабинете» нужно выбрать частичное погашение: вернуть часть основного долга и сократить срок займа.',
							},
							{
								name: 'extend-term',
								text: 'Можно ли продлить срок микрокредита?',
								content: 'Продление срока пользования микрокредитом не предусмотрено: его нужно вернуть не позднее указанного в договоре срока.',
							},
						]
					},
					{
						name: 'business-line',
						text: 'Бизнес кредит',
						content: [
							{
								name: 'return-money',
								text: 'Как можно вернуть деньги?',
								content: 'Есть несколько способов вернуть деньги:<br/><br/>' +
								'<ul class="questions-answers__block-num-list">' +
								'<li>банковской картой Visa или MasterCard в личном кабинете на microfin.kz,</li>' +
								'<li>с помощью кошельков Qiwi Wallet или «Личная касса — Касса 24»,</li>' +
								'<li>банковским переводом.</li>' +
								'</ul><br/><br/>' +
								'Подробнее о механизме возврата – <a href="">в разделе «Как вернуть деньги»</a>.',
							},
							{
								name: 'return-preferable',
								text: 'Какой способ возврата предпочтительнее?',
								content: 'Всё зависит от ваших предпочтений, выбирайте самый удобный способ для вас.',
							},
							{
								name: 'credit-repayment-business-line',
								text: 'Каков порядок возврата микрокредита?',
								content: 'В течение срока действия кредитного договора вы ежемесячно выплачиваете вознаграждение по микрокредиту, а сумму основного долга полностью погашаете последним платежом.',
							},
							{
								name: 'early-loan-business-line',
								text: 'Можно ли вернуть микрокредит досрочно?',
								content: 'Да, можно. Для этого в «Личном кабинете» выберите опцию полного досрочного погашения.',
							},
							{
								name: 'credit-term-line',
								text: 'Можно ли сократить срок микрокредита?',
								content: 'Вы можете сократить срок через 3 месяца использования транша, досрочно или частично досрочно погасив сумму микрокредита и вознаграждения. Для этого вам нужно зайти в «Личный кабинет» и выбрать соответствующую опцию.',
							},
							{
								name: 'new-tranche-business-line',
								text: 'Можно ли получить новый транш, не вернув предыдущий?',
								content: 'Это невозможно. После того, как вернёте первый транш в срок, сможете получить следующий с большей суммой.',
							},
							{
								name: 'extend-term',
								text: 'Можно ли продлить срок микрокредита?',
								content: 'Продление срока пользования микрокредитом не предусмотрено: его нужно вернуть не позднее указанного в договоре срока.',
							},
						]
					},
				]
			},
			{
				name: 'repayment-loan',
				list: [
					{
						name: 'opportunities-time',
						text: 'Нет возможности вовремя сделать платёж. Чем это мне грозит?',
						content: 'За просроченный платеж мы начисляем штрафы. Однако, мы предоставляем грейс период по оплате ежемесячного платежа в течении 3 дней с даты платежа по графику, и если Вы не оплатите платеж, согласно установленных требований, то за каждый случай выхода на просрочку, Вы платите разовую штрафную комиссию 3 000 тенге и ежедневные штрафные санкции в размере 0,5% от суммы просроченного основного долга. Просрочка отразится в вашей кредитной истории. Не допускайте просроченных платежей.'
					},
					{
						name: 'restructure-debt',
						text: 'Можно ли реструктурировать долг?',
						content: 'Реструктуризация долга не предусмотрена. Но вы можете отправить заявку с подробным описанием сложившейся ситуации. Мы можем рассмотреть обращение в индивидуальном порядке.'
					},
				]
			},
			{
				name: 'personal-area',
				list: [
					{
						name: 'can-not-remember',
						text: 'Не могу вспомнить пароль от «Личного кабинета»',
						content: 'На странице авторизации нажмите на ссылку «Восстановить пароль». Введите в открывшемся поле номер мобильного телефона, который указывали при регистрации. В течение минуты вы получите sms-сообщение с кодом, введите его в появившемся поле. После этого можете установить новый пароль.<br/><br/>' +
						'Если нет доступа к мобильному телефону, напишите нам на <a href="mailto:salem@micro.kz">salem@micro.kz</a> и приложите к сообщению копию удостоверения личности или паспорта. Мы отправим инструкцию по смене пароля на вашу почту.'
					},
					{
						name: 'credit-not-sent',
						text: 'Заявка на микрокредит не отправляется',
						content: 'Если вы успешно прошли дополнительную верификацию, но по-прежнему не можете отправить заявку, свяжитесь с нашим.'
					},
					{
						name: 'account-locked',
						text: 'Мой «Личный кабинет» заблокирован',
						content: 'Узнать причину блокировки можно в нашем Контакт-центре. Для разблокировки нужно отправить на наш адрес <a href="mailto:salem@micro.kz"> копию удостоверения личности или паспорта – или подтвердить личные данные по телефону Контакт-центра.'
					},
					{
						name: 'identification-lost',
						text: 'Удостоверение личности или паспорт утеряны. Как изменить данные в «Личном кабинете»?',
						content: 'Отправьте нам письмо на <a href="mailto:salem@micro.kz"> и прикрепите копию нового удостоверения или паспорта. Пароль и другие личные данные сможете изменить самостоятельно в «Личном кабинете».'
					},
				]
			},
		],
	},
	mutations: {},
	actions: {},
	getters: {
		question: (state) => (name) => {
			return find(state.listContent, ['name', name]);
		}
	}
};

export default faq;
